import api from "../config";
import URLS from "../../constants/urls";
export const _getZonesBySiteID = async (siteId, pageNumber, pageSize) => {
    const response = await api.get(`${URLS.ZONE}/${siteId}?pageNumber=${pageNumber}&pageSize=${pageSize}`);
    return response.data;
};
